import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ba0fd2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-selector-root" }
const _hoisted_2 = { class: "top-view-selector" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useGlobalStore, TOP_VIEW_TYPES } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const graphicalTitle = computed(() => {
  return initDataStore.initData.layoutInfo.top.graphical.title
})
const summaryTitle = computed(() => {
  return initDataStore.initData.layoutInfo.top.summary.title
})

const router = useRouter()
const toggleViewType = (viewType: string) => {
  if (viewType === TOP_VIEW_TYPES.GRAPHICAL) {
    router.push(`/top/${TOP_VIEW_TYPES.GRAPHICAL}`)
  } else {
    router.push(`/top/${TOP_VIEW_TYPES.SUMMARY}`)
  }
}

const selectorClass = (type: string) => {
  return {
    active: type === globalStore.top.viewType,
  }
}
const topViewTypes = TOP_VIEW_TYPES

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleViewType(_unref(topViewTypes).GRAPHICAL))),
        class: _normalizeClass(selectorClass(_unref(topViewTypes).GRAPHICAL))
      }, _toDisplayString(_unref(graphicalTitle)), 3),
      _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleViewType(_unref(topViewTypes).SUMMARY))),
        class: _normalizeClass(selectorClass(_unref(topViewTypes).SUMMARY))
      }, _toDisplayString(_unref(summaryTitle)), 3)
    ])
  ]))
}
}

})